<template>
  <div>
    <Titel title="Unsere Idee - Lausitz mit Zukunft?!" />
    <p>Mit <router-link to="Konzept">unserem Konzept</router-link> wollen wir erreichen, dass die Betroffenen im Rahmen des Struktur&shy;wandels eine Stimme bekommen und mit Hilfe eines eigenen Budgets ihre eigenen Entscheidungen treffen können. Dabei soll es aber nicht darum gehen, den politischen Akteuren Kompetenzen streitig zu machen; vielmehr soll durch die Verteilung eines Teils des vom Bund geplanten Geldes durch die BürgerInnen ein Beitrag zum Gelingen des Wandels geleistet werden. Dies gelingt, indem die sogenannten <b>weichen Standort&shy;faktoren</b>, also solche, die sich direkt auf die Lebensqualität auswirken, von denen bestimmt werden, die in diesem Bereich die besten Experten sind: die BürgerInnen selbst!</p>
    <p>Dazu haben wir einen <router-link to="Konzept">Plan</router-link> entwickelt, mit dem die <b>Beteiligung aller BürgerInnen</b> organisiert werden kann, ohne dabei durch die Vielzahl der Interessen den Überblick zu verlieren. Mit einer Kombination aus gelosten Bürger&shy;räten und lokalen Politikern, die mit Hilfe von Experten über die Zulassung von Projekt&shy;vorschlägen beraten, erreichen wir ein möglichst repräsentatives und damit aussagekräftiges Ergebnis. Im Allgemeinen sollen durch die von uns vorge&shy;schlagenen Strukturen <b>Projektideen</b> generiert, ausgewählt und nach einer Abstimmung durch alle BürgerInnen umgesetzt werden.</p>
    <p>Die Grundidee lässt sich dabei mit einer <b>Sanduhr</b> vergleichen. Am Anfang unseres Prozesses können alle BürgerInnen Ideen und Vorschläge einbringen, die dann in einem Kontroll&shy;gremium beraten werden. Schluss&shy;endlich stehen die zugelassenen Projekte wiederum zur Wahl unter allen BürgerInnen der jeweils von der Idee betroffenen Region.</p>
    <p><router-link to="Konzept">Hier</router-link> wird das Konzept näher vorgestellt.</p>
  </div>
</template>

<script>
import Titel from '@/components/Titel'

export default {
  name: 'Idee',

  components: {
    Titel
  },

  data () {
    return {

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Idee.vue